module.exports = __webpack_public_path__ + "img/1def_Dashboard.d2be3803.png";